/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  AddAddressAreaRequest,
  AddVendorCategoryRequest,
  BadRequestErrorResponse,
  BillingCategoryApiResource,
  ConflictErrorResponse,
  CreateVendorRequest,
  DeleteApiVendorCategoriesRemove400,
  GetApiVendorAddressAreasList200,
  GetApiVendorAddressAreasListParams,
  GetApiVendorList200,
  GetApiVendorListParams,
  GetApiVendorsByAddressArea200,
  GetApiVendorsByAddressAreaParams,
  NotFoundErrorResponse,
  PutApiCurrentVendorUpdate200,
  UnauthorizedErrorResponse,
  UpdateVendorRequest,
  VendorAddressAreaApiResource,
  VendorApiResource,
  VendorCategoryApiResource
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiVendorAddressAreasListResponse200 = {
  data: GetApiVendorAddressAreasList200
  status: 200
}

export type getApiVendorAddressAreasListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiVendorAddressAreasListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiVendorAddressAreasListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiVendorAddressAreasListResponseSuccess = (getApiVendorAddressAreasListResponse200) & {
  headers: Headers;
};
export type getApiVendorAddressAreasListResponseError = (getApiVendorAddressAreasListResponse401 | getApiVendorAddressAreasListResponse403 | getApiVendorAddressAreasListResponse404) & {
  headers: Headers;
};

export type getApiVendorAddressAreasListResponse = (getApiVendorAddressAreasListResponseSuccess | getApiVendorAddressAreasListResponseError)

export const getGetApiVendorAddressAreasListUrl = (id: number,
    params?: GetApiVendorAddressAreasListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vendors/${id}/address-areas?${stringifiedParams}` : `/api/vendors/${id}/address-areas`
}

export const getApiVendorAddressAreasList = async (id: number,
    params?: GetApiVendorAddressAreasListParams, options?: RequestInit): Promise<getApiVendorAddressAreasListResponse> => {
  
  return customFetch<getApiVendorAddressAreasListResponse>(getGetApiVendorAddressAreasListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiVendorAddressAreaAddResponse201 = {
  data: VendorAddressAreaApiResource[]
  status: 201
}

export type postApiVendorAddressAreaAddResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiVendorAddressAreaAddResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiVendorAddressAreaAddResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiVendorAddressAreaAddResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiVendorAddressAreaAddResponseSuccess = (postApiVendorAddressAreaAddResponse201) & {
  headers: Headers;
};
export type postApiVendorAddressAreaAddResponseError = (postApiVendorAddressAreaAddResponse400 | postApiVendorAddressAreaAddResponse401 | postApiVendorAddressAreaAddResponse403 | postApiVendorAddressAreaAddResponse404) & {
  headers: Headers;
};

export type postApiVendorAddressAreaAddResponse = (postApiVendorAddressAreaAddResponseSuccess | postApiVendorAddressAreaAddResponseError)

export const getPostApiVendorAddressAreaAddUrl = (id: number,) => {


  

  return `/api/vendors/${id}/address-areas`
}

export const postApiVendorAddressAreaAdd = async (id: number,
    addAddressAreaRequest: AddAddressAreaRequest, options?: RequestInit): Promise<postApiVendorAddressAreaAddResponse> => {
  
  return customFetch<postApiVendorAddressAreaAddResponse>(getPostApiVendorAddressAreaAddUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addAddressAreaRequest,)
  }
);}


export type getApiVendorCategoriesListResponse200 = {
  data: BillingCategoryApiResource[]
  status: 200
}

export type getApiVendorCategoriesListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiVendorCategoriesListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiVendorCategoriesListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiVendorCategoriesListResponseSuccess = (getApiVendorCategoriesListResponse200) & {
  headers: Headers;
};
export type getApiVendorCategoriesListResponseError = (getApiVendorCategoriesListResponse401 | getApiVendorCategoriesListResponse403 | getApiVendorCategoriesListResponse404) & {
  headers: Headers;
};

export type getApiVendorCategoriesListResponse = (getApiVendorCategoriesListResponseSuccess | getApiVendorCategoriesListResponseError)

export const getGetApiVendorCategoriesListUrl = (id: number,) => {


  

  return `/api/vendors/${id}/categories`
}

export const getApiVendorCategoriesList = async (id: number, options?: RequestInit): Promise<getApiVendorCategoriesListResponse> => {
  
  return customFetch<getApiVendorCategoriesListResponse>(getGetApiVendorCategoriesListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiVendorCategoriesAddResponse201 = {
  data: VendorCategoryApiResource
  status: 201
}

export type postApiVendorCategoriesAddResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiVendorCategoriesAddResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiVendorCategoriesAddResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiVendorCategoriesAddResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiVendorCategoriesAddResponseSuccess = (postApiVendorCategoriesAddResponse201) & {
  headers: Headers;
};
export type postApiVendorCategoriesAddResponseError = (postApiVendorCategoriesAddResponse400 | postApiVendorCategoriesAddResponse401 | postApiVendorCategoriesAddResponse403 | postApiVendorCategoriesAddResponse404) & {
  headers: Headers;
};

export type postApiVendorCategoriesAddResponse = (postApiVendorCategoriesAddResponseSuccess | postApiVendorCategoriesAddResponseError)

export const getPostApiVendorCategoriesAddUrl = (id: number,) => {


  

  return `/api/vendors/${id}/categories`
}

export const postApiVendorCategoriesAdd = async (id: number,
    addVendorCategoryRequest: AddVendorCategoryRequest, options?: RequestInit): Promise<postApiVendorCategoriesAddResponse> => {
  
  return customFetch<postApiVendorCategoriesAddResponse>(getPostApiVendorCategoriesAddUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addVendorCategoryRequest,)
  }
);}


export type getApiVendorListResponse200 = {
  data: GetApiVendorList200
  status: 200
}

export type getApiVendorListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiVendorListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiVendorListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiVendorListResponseSuccess = (getApiVendorListResponse200) & {
  headers: Headers;
};
export type getApiVendorListResponseError = (getApiVendorListResponse400 | getApiVendorListResponse401 | getApiVendorListResponse403) & {
  headers: Headers;
};

export type getApiVendorListResponse = (getApiVendorListResponseSuccess | getApiVendorListResponseError)

export const getGetApiVendorListUrl = (params?: GetApiVendorListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vendors?${stringifiedParams}` : `/api/vendors`
}

export const getApiVendorList = async (params?: GetApiVendorListParams, options?: RequestInit): Promise<getApiVendorListResponse> => {
  
  return customFetch<getApiVendorListResponse>(getGetApiVendorListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiCurrentVendorUpdateResponse200 = {
  data: PutApiCurrentVendorUpdate200
  status: 200
}

export type putApiCurrentVendorUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiCurrentVendorUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiCurrentVendorUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiCurrentVendorUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiCurrentVendorUpdateResponseSuccess = (putApiCurrentVendorUpdateResponse200) & {
  headers: Headers;
};
export type putApiCurrentVendorUpdateResponseError = (putApiCurrentVendorUpdateResponse400 | putApiCurrentVendorUpdateResponse401 | putApiCurrentVendorUpdateResponse403 | putApiCurrentVendorUpdateResponse409) & {
  headers: Headers;
};

export type putApiCurrentVendorUpdateResponse = (putApiCurrentVendorUpdateResponseSuccess | putApiCurrentVendorUpdateResponseError)

export const getPutApiCurrentVendorUpdateUrl = () => {


  

  return `/api/vendors`
}

export const putApiCurrentVendorUpdate = async (updateVendorRequest: UpdateVendorRequest, options?: RequestInit): Promise<putApiCurrentVendorUpdateResponse> => {
  
  return customFetch<putApiCurrentVendorUpdateResponse>(getPutApiCurrentVendorUpdateUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateVendorRequest,)
  }
);}


export type postApiVendorCreateResponse201 = {
  data: VendorApiResource
  status: 201
}

export type postApiVendorCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiVendorCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiVendorCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiVendorCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiVendorCreateResponseSuccess = (postApiVendorCreateResponse201) & {
  headers: Headers;
};
export type postApiVendorCreateResponseError = (postApiVendorCreateResponse400 | postApiVendorCreateResponse401 | postApiVendorCreateResponse403 | postApiVendorCreateResponse409) & {
  headers: Headers;
};

export type postApiVendorCreateResponse = (postApiVendorCreateResponseSuccess | postApiVendorCreateResponseError)

export const getPostApiVendorCreateUrl = () => {


  

  return `/api/vendors`
}

export const postApiVendorCreate = async (createVendorRequest: CreateVendorRequest, options?: RequestInit): Promise<postApiVendorCreateResponse> => {
  
  return customFetch<postApiVendorCreateResponse>(getPostApiVendorCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createVendorRequest,)
  }
);}


export type deleteApiVendorAddressAreaDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiVendorAddressAreaDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiVendorAddressAreaDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiVendorAddressAreaDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiVendorAddressAreaDeleteResponseSuccess = (deleteApiVendorAddressAreaDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiVendorAddressAreaDeleteResponseError = (deleteApiVendorAddressAreaDeleteResponse401 | deleteApiVendorAddressAreaDeleteResponse403 | deleteApiVendorAddressAreaDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiVendorAddressAreaDeleteResponse = (deleteApiVendorAddressAreaDeleteResponseSuccess | deleteApiVendorAddressAreaDeleteResponseError)

export const getDeleteApiVendorAddressAreaDeleteUrl = (id: number,
    areaId: number,) => {


  

  return `/api/vendors/${id}/address-areas/${areaId}`
}

export const deleteApiVendorAddressAreaDelete = async (id: number,
    areaId: number, options?: RequestInit): Promise<deleteApiVendorAddressAreaDeleteResponse> => {
  
  return customFetch<deleteApiVendorAddressAreaDeleteResponse>(getDeleteApiVendorAddressAreaDeleteUrl(id,areaId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type getApiVendorsByAddressAreaResponse200 = {
  data: GetApiVendorsByAddressArea200
  status: 200
}

export type getApiVendorsByAddressAreaResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiVendorsByAddressAreaResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiVendorsByAddressAreaResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiVendorsByAddressAreaResponseSuccess = (getApiVendorsByAddressAreaResponse200) & {
  headers: Headers;
};
export type getApiVendorsByAddressAreaResponseError = (getApiVendorsByAddressAreaResponse400 | getApiVendorsByAddressAreaResponse401 | getApiVendorsByAddressAreaResponse403) & {
  headers: Headers;
};

export type getApiVendorsByAddressAreaResponse = (getApiVendorsByAddressAreaResponseSuccess | getApiVendorsByAddressAreaResponseError)

export const getGetApiVendorsByAddressAreaUrl = (params: GetApiVendorsByAddressAreaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vendors/by-address-area?${stringifiedParams}` : `/api/vendors/by-address-area`
}

export const getApiVendorsByAddressArea = async (params: GetApiVendorsByAddressAreaParams, options?: RequestInit): Promise<getApiVendorsByAddressAreaResponse> => {
  
  return customFetch<getApiVendorsByAddressAreaResponse>(getGetApiVendorsByAddressAreaUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type deleteApiVendorCategoriesRemoveResponse204 = {
  data: void
  status: 204
}

export type deleteApiVendorCategoriesRemoveResponse400 = {
  data: DeleteApiVendorCategoriesRemove400
  status: 400
}

export type deleteApiVendorCategoriesRemoveResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiVendorCategoriesRemoveResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiVendorCategoriesRemoveResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiVendorCategoriesRemoveResponseSuccess = (deleteApiVendorCategoriesRemoveResponse204) & {
  headers: Headers;
};
export type deleteApiVendorCategoriesRemoveResponseError = (deleteApiVendorCategoriesRemoveResponse400 | deleteApiVendorCategoriesRemoveResponse401 | deleteApiVendorCategoriesRemoveResponse403 | deleteApiVendorCategoriesRemoveResponse404) & {
  headers: Headers;
};

export type deleteApiVendorCategoriesRemoveResponse = (deleteApiVendorCategoriesRemoveResponseSuccess | deleteApiVendorCategoriesRemoveResponseError)

export const getDeleteApiVendorCategoriesRemoveUrl = (id: number,
    categoryId: number,) => {


  

  return `/api/vendors/${id}/categories/${categoryId}`
}

export const deleteApiVendorCategoriesRemove = async (id: number,
    categoryId: number, options?: RequestInit): Promise<deleteApiVendorCategoriesRemoveResponse> => {
  
  return customFetch<deleteApiVendorCategoriesRemoveResponse>(getDeleteApiVendorCategoriesRemoveUrl(id,categoryId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type deleteApiVendorArchiveResponse204 = {
  data: void
  status: 204
}

export type deleteApiVendorArchiveResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiVendorArchiveResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiVendorArchiveResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiVendorArchiveResponseSuccess = (deleteApiVendorArchiveResponse204) & {
  headers: Headers;
};
export type deleteApiVendorArchiveResponseError = (deleteApiVendorArchiveResponse401 | deleteApiVendorArchiveResponse403 | deleteApiVendorArchiveResponse404) & {
  headers: Headers;
};

export type deleteApiVendorArchiveResponse = (deleteApiVendorArchiveResponseSuccess | deleteApiVendorArchiveResponseError)

export const getDeleteApiVendorArchiveUrl = (id: number,) => {


  

  return `/api/vendors/${id}/archive`
}

export const deleteApiVendorArchive = async (id: number, options?: RequestInit): Promise<deleteApiVendorArchiveResponse> => {
  
  return customFetch<deleteApiVendorArchiveResponse>(getDeleteApiVendorArchiveUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type getApiVendorGetResponse200 = {
  data: VendorApiResource
  status: 200
}

export type getApiVendorGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiVendorGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiVendorGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiVendorGetResponseSuccess = (getApiVendorGetResponse200) & {
  headers: Headers;
};
export type getApiVendorGetResponseError = (getApiVendorGetResponse401 | getApiVendorGetResponse403 | getApiVendorGetResponse404) & {
  headers: Headers;
};

export type getApiVendorGetResponse = (getApiVendorGetResponseSuccess | getApiVendorGetResponseError)

export const getGetApiVendorGetUrl = (id: number,) => {


  

  return `/api/vendors/${id}`
}

export const getApiVendorGet = async (id: number, options?: RequestInit): Promise<getApiVendorGetResponse> => {
  
  return customFetch<getApiVendorGetResponse>(getGetApiVendorGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiVendorUpdateResponse200 = {
  data: VendorApiResource
  status: 200
}

export type putApiVendorUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiVendorUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiVendorUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiVendorUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiVendorUpdateResponseSuccess = (putApiVendorUpdateResponse200) & {
  headers: Headers;
};
export type putApiVendorUpdateResponseError = (putApiVendorUpdateResponse400 | putApiVendorUpdateResponse401 | putApiVendorUpdateResponse403 | putApiVendorUpdateResponse409) & {
  headers: Headers;
};

export type putApiVendorUpdateResponse = (putApiVendorUpdateResponseSuccess | putApiVendorUpdateResponseError)

export const getPutApiVendorUpdateUrl = (id: number,) => {


  

  return `/api/vendors/${id}`
}

export const putApiVendorUpdate = async (id: number,
    updateVendorRequest: UpdateVendorRequest, options?: RequestInit): Promise<putApiVendorUpdateResponse> => {
  
  return customFetch<putApiVendorUpdateResponse>(getPutApiVendorUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateVendorRequest,)
  }
);}


